import { createFileRoute } from '@tanstack/react-router';
import { AppEmbed as AppEmbedType } from '@thoughtspot/visual-embed-sdk';
import { AppEmbed, useEmbedRef } from '@thoughtspot/visual-embed-sdk/react';
import { useUserAppViewConfig } from '@/api/queries/useSdkTokenQuery';

export const Route = createFileRoute('/dashboard/_deep-links/data/$guid')({
  component: RouteComponent,
});

function RouteComponent() {
  const { guid } = Route.useParams();

  const embedRef = useEmbedRef() as React.RefObject<AppEmbedType>;
  const userAppViewConfig = useUserAppViewConfig();
  return (
    <AppEmbed
      className="h-screen w-full"
      ref={embedRef}
      liveboardV2={true}
      enableAskSage={true}
      modularHomeExperience={true}
      dataPanelV2={true}
      // TODO: waiting for TS support verification whether the flag also needs to be explicitly passed on those deep-link routes
      enableCustomColumnGroups={true}
      additionalFlags={{ enableCustomColumnGroups: true }}
      path={`data/tables/${guid}`}
      {...(userAppViewConfig?.hiddenActions && {
        hiddenActions: userAppViewConfig.hiddenActions,
      })}
      {...(userAppViewConfig?.homePageSearchBarMode && {
        homePageSearchBarMode: userAppViewConfig.homePageSearchBarMode,
      })}
    ></AppEmbed>
  );
}
